import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route, Switch } from "react-router";
import { LayoutProperties } from "../../../layouts/Layout";
import SmsVerification from "../../../forms/SmsVerification";
import Login from "../../../forms/Login";
import styles from "./styles.module.css";

export default React.memo(() => {
  const isPhoneExist = useSelector(({ authorization }) => !!authorization?.phone);

  return (
    <LayoutProperties horizontalPosition="center" verticalPosition="bottom">
      <div className={styles.formContainer}>
        <Switch>
          {isPhoneExist &&
          <>
            <Route
              path={"/login/verification"}
              component={SmsVerification}
            />
            <Redirect to={"/login/verification"} />
          </>
          }
          <Route
            path={"/login/auth"}
            component={Login}
          />
          <Redirect to={"/login/auth"} />
        </Switch>
      </div>
    </LayoutProperties>
  );
});
